import React from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '../components/Layout';

const Privacy = () => {
    return (
        <Layout>
            <Helmet>
                <title>Privacy Policy - MyEnAb</title>
                <meta name="description" content="Privacy Policy for MyEnAb platform." />
            </Helmet>
            <div className="max-w-4xl mx-auto px-4 py-12 text-zinc-300">
                <h1 className="text-4xl font-lexend font-bold text-white mb-8">Privacy Policy</h1>
                <div className="space-y-6 text-lg">
                    <p>Last updated: {new Date().toLocaleDateString()}</p>
                    
                    <h2 className="text-2xl font-bold text-white mt-8">1. Introduction</h2>
                    <p>Welcome to MyEnAb. We are committed to protecting your personal data and your privacy. This policy explains how we collect, use, and safeguard your information in compliance with the General Data Protection Regulation (GDPR) and the California Consumer Privacy Act (CCPA).</p>

                    <h2 className="text-2xl font-bold text-white mt-8">2. Information We Collect</h2>
                    <p>We collect information that identifies, relates to, or could reasonably be linked with you ("Personal Information"). This includes:</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>Identifiers:</strong> Name, email address, username, IP address.</li>
                        <li><strong>Protected Classifications:</strong> Information regarding disabilities (which you provide voluntarily to customize your experience).</li>
                        <li><strong>Geolocation Data:</strong> General location provided during registration.</li>
                        <li><strong>Professional/Employment Information:</strong> For NGOs and Service Providers.</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-white mt-8">3. GDPR Compliance (EU Users)</h2>
                    <p>If you are located in the European Economic Area (EEA), you have specific rights under the GDPR:</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>Lawful Basis:</strong> We process your data based on Performance of a Contract (providing platform services) and your explicit Consent (for sensitive health/disability data).</li>
                        <li><strong>Right to Access & Portability:</strong> You can request a copy of your data via our export tool.</li>
                        <li><strong>Right to Erasure ("Right to be Forgotten"):</strong> You can request the permanent deletion of your account and associated data.</li>
                        <li><strong>Right to Rectification:</strong> You can update your profile information at any time.</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-white mt-8">4. CCPA Compliance (California Residents)</h2>
                    <p>California residents have the following rights:</p>
                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>Right to Know:</strong> The right to know what personal information is collected, used, shared, or sold.</li>
                        <li><strong>Right to Delete:</strong> The right to request the deletion of personal information.</li>
                        <li><strong>Right to Opt-Out:</strong> MyEnAb <strong>does not sell</strong> your personal information to third parties.</li>
                        <li><strong>Non-Discrimination:</strong> We will not discriminate against you for exercising your privacy rights.</li>
                    </ul>

                    <h2 className="text-2xl font-bold text-white mt-8">5. Data Security & PII Encryption</h2>
                    <p>We use industry-standard AES-256-GCM encryption to protect your Personally Identifiable Information (PII) at rest. Your email and name are encrypted in our database, and only hashed identifiers are used for lookups to ensure maximum security.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">6. Data Retention</h2>
                    <p>We retain your personal information only for as long as necessary to provide you with our services and as described in this policy. You can delete your account at any time, which triggers the permanent removal of your personal data from our active systems.</p>

                    <h2 className="text-2xl font-bold text-white mt-8">7. Contact Us</h2>
                    <p>For any privacy-related inquiries or to exercise your rights, please contact our Data Protection Officer at <strong>privacy@myenab.com</strong>.</p>
                </div>
            </div>
        </Layout>
    );
};

export default Privacy;
